<template>
	<div class="h-auto space-y-1" ref="editableDiv">
		<p
			ref="commentElement"
			class="font-normal whitespace-pre-wrap break-normal overflow-wrap-anywhere"
			v-if="log.comment"
			:contenteditable="page.props.auth.user?.role == 'admin' || page.props.auth.user?.id == log.user_id"
			@click="isEditable = true"
			@input="updateComment">
			{{ log.comment }}
		</p>
		<div v-if="isEditable" class="flex justify-start gap-4 mt-2">
			<button @click="saveComment" class="px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600">Sauvegarder</button>
			<button @click="isEditable = false" class="px-3 py-1 bg-gray-300 rounded hover:bg-gray-400">Annuler</button>
		</div>
	</div>
</template>

<script setup>
	import { ref, onMounted, onBeforeUnmount } from 'vue';
	import { usePage } from '@inertiajs/vue3';
	import { toast } from 'vue3-toastify';
	import axios from 'axios';

	const page = usePage();

	const props = defineProps({
		log: {
			type: Object,
			required: true,
		},
	});

	const isEditable = ref(false);
	const comment = ref(props.log.comment);
	const editableDiv = ref(null);

	const updateComment = (e) => {
		comment.value = e.target.innerText;
	};

	const saveComment = () => {
		axios
			.post(route('log.updateComment', { log: props.log.id }), { comment: comment.value, log_id: props.log.id })
			.then((response) => {
				toast.success('Commentaire sauvegardé');
				isEditable.value = false;
			})
			.catch((error) => {
				if (error.response?.data?.error) {
					toast.error(error.response.data.error);
				} else {
					toast.error('La requête a échoué avec le code ' + error.response?.status);
				}
				isEditable.value = false;
			});
	};

	const clickAway = (event) => {
		if (editableDiv.value && !editableDiv.value.contains(event.target)) {
			isEditable.value = false;
		}
	};

	onMounted(() => {
		document.addEventListener('click', clickAway);
	});

	onBeforeUnmount(() => {
		document.removeEventListener('click', clickAway);
	});
</script>
